import styles from './ClosedMenu.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';
import { withSidebarContext } from 'src/components/SidebarContext/WithSidebarContext';
import { Link } from '../../../api/contentful/contentTypes.cloverdotcom';
import { isEntry } from '../../../utils/EntryUtil';
import { ContentLink } from '../../ContentLink/ContentLink';

export interface IClosed extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: never;
  title?: string;
  isOpenable?: boolean;
  linkWhenNotOpenable?: ReferencedEntry<Link>;
}

const ClosedMenu: React.FC<IClosed> = ({
  hidden,
  className,
  title,
  isOpenable,
  linkWhenNotOpenable,
  ...props
}) => {
  const button = (
    <button
      tabIndex={hidden ? -1 : 0}
      className={cx(styles.closedMenu, { [styles.closedMenuHidden]: hidden }, className)}
      aria-hidden={hidden ? true : undefined}
      {...props}
    >
      {title}
    </button>
  );

  return isOpenable || !isEntry(linkWhenNotOpenable)
      ? button
      : (<ContentLink entry={linkWhenNotOpenable} hideTitle>{button}</ContentLink>);
};

const SidebarContexted = withSidebarContext(({ open, isOpenable }) => ({ onClick: open as any, isOpenable }))(ClosedMenu);

export {
  ClosedMenu as _ClosedMenu,
  SidebarContexted as ClosedMenu,
};
